import React, { forwardRef, useState, useEffect, useMemo } from "react";
import Modal from "react-bootstrap/Modal";
import Select, { StylesConfig } from "react-select";
import CreatableSelect from 'react-select/creatable';
import { components } from 'react-select';
import { AiOutlineSearch, AiOutlineMinus, AiOutlineFileSearch, AiOutlinePlus, AiOutlineUserAdd } from "react-icons/ai";
import { MdOutlineClose, MdArrowForwardIos, MdOutlineCalendarToday, MdOutlineRefresh, MdArrowForward, MdUpdate, MdCheck, MdOutlineMoreVert, MdContentCopy } from "react-icons/md";
import DatePicker from "react-datepicker";
import { instance } from "./axios";
import { format, isValid, parse } from 'date-fns';
import { BsFillExclamationTriangleFill } from 'react-icons/bs'
import { Link, useLocation, useNavigate } from "react-router-dom";
import { MdEdit, MdClose, MdOutlineDelete, MdAccessTime, MdOutlineKeyboardArrowDown, MdOutlineArrowBack } from "react-icons/md";
import { BsArrowRightCircle } from 'react-icons/bs'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import "react-datepicker/dist/react-datepicker.css";
import { GoPlus } from "react-icons/go";
import AsyncSelect from 'react-select/async';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import { HiOutlineRefresh } from 'react-icons/hi'
import { BsImageFill, BsFillGearFill } from "react-icons/bs";
import { BiShow, BiHide } from 'react-icons/bi'
import { useStore } from "./state.js";
import { useQuery, useQueryClient, select } from "react-query";
import { Select as Select1, Avatar as Avatar1, Tooltip as Tooltip1, Input } from 'antd';

import NiceModal, { useModal } from "@ebay/nice-modal-react";

const { Option } = Select1;







export const UiToggle = forwardRef(({ id, name, pclass, loading, title, ...props }, ref) => {
  return (
    <>
      {loading ? (
        <span className="spinner-border spinner-border-sm"></span>
      ) : (

        <div className={`form-check form-switch ${pclass ? '' : 'mb-4'}`}>
          <input
            className="form-check-input"
            type="checkbox"
            role="switch"
            name={name}
            ref={ref}
            id={id}
            {...props}
          />
          <label className="form-check-label" htmlFor={id}>
            {title}
          </label>
        </div>

      )}
    </>
  );
});


export const UiRSelect = forwardRef(
  (
    {

      label,
      required,
      placeholder,
      className,
      lcol,
      icol,
      message,
      addnew,
      handleNew,
      ...props
    },
    ref
  ) => {
    const MenuList = (
      props
    ) => {
      return (
        <components.MenuList {...props}>

          {props.children}
          <div className="p-2">
            <button className="btn btn-outline-secondary w-100" onClick={() => handleNew()}><span className="sicon"><GoPlus /></span> Add New</button>
          </div>
        </components.MenuList>
      );
    };
    return (

      <div className={`mb-4 ${lcol ? "row" : ""}`}>
        <label
          className={`form-label fs-6 fw-bolder text-dark ${lcol ? "col-sm-" + lcol : ""
            }`}
        >
          {label}{" "}
          <span className="text-red-500 font-bold text-lg">
            {required && "*"}
          </span>
        </label>
        <div className={icol ? "col-sm-" + icol : ""}>
          <Select
            ref={ref}
            components={addnew && { MenuList }}
            className={`rselect ${message ? "is-invalid" : ""
              } ${className}`}

            {...props}
          />
          {message && <div className="invalid-feedback">{message}</div>}
        </div>
      </div>
    );
  }
);



export const UiTagInput = forwardRef(
  (
    {

      label,
      required,
      placeholder,
      className,
      lcol,
      icol,
      message,
      ...props
    },
    ref
  ) => {
    return (
      <div className={`mb-4 ${lcol ? "row" : ""}`}>
        <label
          className={`form-label  ${lcol ? "col-sm-" + lcol : ""
            }`}
        >
          {label}{" "}
          <span className="text-red-500 font-bold text-lg">
            {required && "*"}
          </span>
        </label>
        <div className={icol ? "col-sm-" + icol : ""}>

          <Select1
            mode="multiple"
            labelInValue ={true}
            ref={ref}
            allowClear
            className={`w-100 ${message ? "is-invalid" : ""} ${className}`}
            placeholder="Please select"
            // defaultValue={['a10', 'c12']}
            {...props}
          />



          {message && <div className="invalid-feedback">{message}</div>}
        </div>
      </div>
    );
  }
);


export const UiSelect = forwardRef(({ icol, className, message, parentClass, lcol, options, label, required, default_val, name, noerror, title, ...props }, ref) => {
  return (
    <div className={`${parentClass ? { parentClass } : "mb-4"} ${lcol ? "row" : ""}`}>
      {label && (
        <label
          className={`form-label ${lcol ? "col-sm-" + lcol : ""
            }`}
        >
          {label}{" "}
          <span className="text-red-500 font-bold text-lg">
            {required && "*"}
          </span>
        </label>
      )}
      <div className={icol ? "col-sm-" + icol : ""}>
        <select
          className={`form-select ${message ? "is-invalid" : ""
            } ${className}`}
          name={name}
          ref={ref}
          {...props}>
          <option></option>
          {(options && options[0] && options[0].value) ? options.map((option, i) => (
            <option value={option.value} key={i}>{option.label}</option>
          )) :
            options.map((option, i) => (
              <option value={option} key={i}>{option}</option>
            ))
          }
        </select>
        {!noerror && message && <div className="invalid-feedback">{message}</div>}

      </div>
    </div>
  );
});


export function UiTFind(props) {
  const { setFilterText, filterText, heading } = props;
  return (
    <div className="input-group flex-nowrap width25">
      <span className="input-group-text" ><AiOutlineSearch /></span>
      {filterText && (<span className="clearbtn" onClick={() => setFilterText('')}><MdOutlineClose /></span>)}
      <input className="form-control" onChange={e => setFilterText(e.target.value)} value={filterText} />

    </div>
  );
}


export const UiDatePicker = forwardRef(({ icol, className, dateFormat, message, lcol, label, required, default_val, name, onChange, title, ...props }, ref) => {
  return (
    <div className={`mb-4 ${lcol ? "row" : ""}`}>
      <label
        className={`form-label ${lcol ? "col-sm-" + lcol : ""
          }`}
      >
        {label}{" "}
        <span className="text-red-500 font-bold text-lg">
          {required && "*"}
        </span>
      </label>
      <div className={icol ? "col-sm-" + icol : ""}>

        <DatePicker
          className={`form-control ${message ? "is-invalid" : ""
            } ${className}`}
          onChange={(e) => onChange(format(e, dateFormat))} // send value to hook form
          selected={(default_val && isValid(parse(default_val, dateFormat, new Date()))) ? parse(default_val, dateFormat, new Date()) : null}
          name={name}
          dateFormat={dateFormat}
          ref={ref}
          {...props}
        />
        {message && <div className="invalid-feedback d-block">{message}</div>}

      </div>
    </div>
  );
});



export const UiTextArea = forwardRef(
  (
    {
      type,
      name,
      parentClass,
      noerror,
      label,
      required,
      placeholder,
      className,
      lcol,
      icol,
      message,
      ...props
    },
    ref
  ) => {
    return (
      <div className={`${parentClass ? { parentClass } : "mb-4"} ${lcol ? "row" : ""}`}>
        {label && (
          <label
            className={`form-label ${lcol ? "col-sm-" + lcol : ""
              }`}
          >
            {label}{" "}
            <span className="text-red-500 font-bold text-lg">
              {required && "*"}
            </span>
          </label>
        )}
        <div className={icol ? "col-sm-" + icol : ""}>
          <textarea
            name={name}
            ref={ref}
            type={type}
            className={`form-control ${message ? "is-invalid" : ""
              } ${className}`}
            placeholder={placeholder}
            autoComplete="off"
            {...props}
          />
          {!noerror && message && <div className="invalid-feedback">{message}</div>}
        </div>
      </div>
    );
  }
);



export const UiFindSelect = forwardRef(
  (
    {

      label,
      required,
      placeholder,
      className,
      lcol,
      icol,
      message,
      ...props
    },
    ref
  ) => {
    return (
      <div className={`mb-4 ${lcol ? "row" : ""}`}>
        <label
          className={`form-label fs-6 fw-bolder text-dark ${lcol ? "col-sm-" + lcol : ""
            }`}
        >
          {label}{" "}
          <span className="text-red-500 font-bold text-lg">
            {required && "*"}
          </span>
        </label>
        <div className={icol ? "col-sm-" + icol : ""}>
          <AsyncSelect
            cacheOptions

            defaultOptions
            noOptionsMessage={() => 'Type to search'}


            isClearable
            components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
            ref={ref}

            className={`rselect ${message ? "is-invalid" : ""
              } ${className}`}

            {...props}


          />
          {message && <div className="invalid-feedback">{message}</div>}
        </div>
      </div>
    );
  }
);


export const Toastcontent = (props) => {
  const userModal = useModal('bulkaction-errors');

  const showAddModal = (row, type) => {
    userModal.show({ data: row, type: type }).then((res) => {

    });
  }
  const { msg, errors, type } = props;
  return (<>
    <span>{msg}</span>
    {errors &&
      <button className="btn btn-secondary btn-sm ms-2" onClick={() => showAddModal(errors, type)}>View errors</button>
    }
  </>
  )
}


export function Avatar(props) {
  let { name, src, className, size, title, round, ...other } = props;

  return (
    <div className="d-flex">



      {(name || src) && (
        <div className={`u_avatar ${className}`} style={{ width: size + 'px', height: size + 'px' }} {...other}>
          {src ? <img src={src} /> : <div style={{ width: size + 'px', height: size + 'px' }}><span>{name.charAt(0)}</span></div>}

        </div>

      )}



    </div>
  );
}


export function UiActionDropDown(props) {
  const { items, className, newclassName, tooltip, title, ...other } = props;
  const [show, setShow] = useState(false);

  return (
    <DropdownMenu
      trigger={({ triggerRef, isSelected, ...props }) => (
        <button className={`${newclassName ? newclassName : 'btn btn-light'} ${className}`}
          {...props}

          ref={triggerRef}
        ><MdOutlineMoreVert /></button>

      )}
    >
      <DropdownItemGroup {...other}>

      </DropdownItemGroup>
    </DropdownMenu>


  )
}


export const BgLoader = forwardRef(
  (
    {
      ...props
    },
    ref
  ) => {
    return (
      <div className="d-flex align-items-center w-100 justify-content-center bgloader my-5" >
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only"></span>
        </div>
      </div>
    );
  }
);


export const PageError = forwardRef(
  (
    {
      msg,
      code,
      ...props
    },
    ref
  ) => {
    return (
      <div className="text-center mt-5">
        <span className="text-warning" style={{ fontSize: '60px' }}><BsFillExclamationTriangleFill /></span>
        <h2>{code == 4 ? 'Not Found!' : msg}</h2>

      </div>

    );
  }
);


export function PageHeader(props) {
  const location = useLocation();
  let navigate = useNavigate();
  const { link, parent, stacked, noBack, title, ...other } = props;
  const doesAnyHistoryEntryExist = location.key !== "default";


  const handleBack = () => {
    if (doesAnyHistoryEntryExist == true) {
      navigate(-1)
    } else {
      navigate("/")
    }
  }
  return (
    <div className={`${stacked == true ? 'd-lg-flex align-items-center' : 'd-flex align-items-center'} my-3`}>
      <div className={`${stacked == true ? 'flex-grow-1' : 'flex-grow-1'}`}><h1 className="d-flex align-items-sm-center flex-sm-row flex-column">
        <div className="d-flex parentpd">{parent && (<><Link className="text-decoration-none" to={link}>{parent}</Link> <span className="sicon mx-1 d-none d-sm-flex"><MdArrowForwardIos /></span></>)} </div><span>{title}</span></h1></div>

      <div className="d-inline-flex" {...other} />
    </div>
  );
}


export const TableZero = forwardRef(
  (
    {
      title,
      ...props
    },
    ref
  ) => {
    return (
      <div className="mb-3 text-center text-muted" >
        <span className="fs-1 d-block text-muted"><AiOutlineFileSearch /></span>
        There are no {title}
      </div>
    );
  }
);



export const UiButton = forwardRef(
  ({ type, name, title, className, icon, loading, disabled, hideloadmsg, ...props }, ref) => {
    return (
      <>
        <button
          name={name}
          ref={ref}
          type={type}
          className={`btn ${icon && 'd-inline-flex'} ${className}`}
          {...props}
          disabled={((loading) || (disabled == 1)) ? "disabled" : ""}
        >
          {loading ? (
            <span className="indicator-progress">
              {hideloadmsg ? '' : 'Please wait...  '}
              <span className="spinner-border spinner-border-sm align-middle"></span>
            </span>
          ) : (
            <>
              {icon == 'add' && <span className="sicon"><GoPlus /></span>}
              {icon == 'go' && <span className="sicon"><BsArrowRightCircle /></span>}
              {icon == 'edit' && <span className="sicon"><MdEdit /></span>}
              {icon == 'delete' && <span className="sicon"><MdOutlineClose /></span>}
              {title && <span className={icon && 'ms-2'} >{title}</span>}
            </>
          )}
        </button>
      </>
    );
  }
);


export function UiActioButton(props) {
  const { action, className, tooltip, type, title, ...other } = props;
  return (
    <OverlayTrigger overlay={<Tooltip >{tooltip ? tooltip : title}</Tooltip>}>

      <button type={type ? type : 'button'} className={`btn bg-white me-1 ${title == 'Delete' ? 'text-danger' : title == 'Close' ? 'text-secondary' : 'text-primary'} ${className}`} onClick={action}>
        {title == 'Edit' && <span className="sicon"><MdEdit /></span>}
        {title == 'Delete' && <span className="sicon"><MdOutlineDelete /></span>}
        {title == 'Go' && <span className="sicon"><MdArrowForward /></span>}
        {title == 'Clear' && <span className="sicon"><MdOutlineRefresh /></span>}
        {title == 'More' && <span className="sicon"><AiOutlinePlus /></span>}
        {title == 'Add' && <span className="sicon"><GoPlus /></span>}
        {title == 'Less' && <span className="sicon"><AiOutlineMinus /></span>}
        {title == 'Refresh' && <span className="sicon"><HiOutlineRefresh /></span>}
        {title == 'UpdateDate' && <span className="sicon"><MdUpdate /></span>}
        {title == 'User' && <span className="sicon"><AiOutlineUserAdd /></span>}
        {title == 'Verify' && <span className="sicon"><MdCheck /></span>}
        {title == 'Copy' && <span className="sicon"><MdContentCopy /></span>}
        {title == 'Settings' && <span className="sicon"><BsFillGearFill /></span>}
        {title == 'Show' && <span className="sicon"><BiShow /></span>}
        {title == 'Hide' && <span className="sicon"><BiHide /></span>}
        {title == 'Close' && <span className="sicon"><MdClose /></span>}
      </button>
    </OverlayTrigger>
  );
}



export const UiInput = forwardRef(
  (
    {
      type,
      name,
      parentClass,
      noerror,
      label,
      required,
      placeholder,
      className,
      max_width,
      lcol,
      icol,
      icon,
      message,
      prefix,
      showicon,
      footer_text,
      ...props
    },
    ref
  ) => {
    const [showpass, setShowpass] = useState(false);
    return (
      <div className={`${parentClass ? parentClass : "mb-4"} ${lcol ? "row" : ""}`}>
        {label && (
          <label
            className={`form-label ${lcol ? "pt-sm-2 col-sm-" + lcol : ""
              }`}
          >
            {label}{" "}
            <span className="text-red font-bold text-lg">
              {required && "*"}
            </span>
          </label>
        )}

        <div className={`${icol && "col-sm-" + icol}`} style={max_width && { maxWidth: max_width }}>
          <div className={`position-relative ${prefix && 'input-group'}`}>
            {prefix && (<span className="input-group-text">{prefix}</span>)}
            {icon == 'inr' && <div className="fieldicon">
              ₹
            </div>}
            {icon == 'percent' && <div className="fieldicon">
              %
            </div>}

            <input
              name={name}
              ref={ref}
              type={showpass == true ? "text" : type}
              className={`form-control form-control-solid ${message ? "is-invalid" : ""} ${icon && 'input_i'} ${showicon && 'input_suf'} ${className}`}
              placeholder={placeholder}
              autoComplete="off"
              {...props}
            />
            {showicon == 1 && <div className="fieldsufx" >
              {showpass == true ? <span className="c-pointer sicon" onClick={() => setShowpass(false)}><BiShow /></span> : <span className="c-pointer sicon" onClick={() => setShowpass(true)}><BiHide /></span>}

            </div>}
            {footer_text &&
              <div className="form-text">{footer_text}</div>
            }
            {!noerror && message && <div className="invalid-feedback">{message}</div>}
          </div>
        </div>
      </div>
    );
  }
);


export const InLoader = forwardRef(
  (
    {
      ...props
    },
    ref
  ) => {
    return (
      <div className="d-flex align-items-center position-absolute skeleton justify-content-center w-100 h-100" style={{ backgroundColor: '#ffffffa8', zIndex: 99 }} >
        <div className="loader1 text-primary"></div>
      </div>
    );
  }
);



export const OverlayLoader = forwardRef(
  (
    {
      visible,
      ...props
    },
    ref
  ) => {
    return (
      <div className={`overlayloader ${visible == true ? '' : 'd-none'}`} >
        <span className="spinner-border align-middle ms-2 text-primary" style={{ width: '3rem', height: '3rem' }}></span>


      </div>
    );
  }
);



export const UiClientSelect = forwardRef(
  (
    {
      label,
      required,
      placeholder,
      loadOptions,
      active,
      className,
      value,
      name,
      onChange,
      key1,
      lcol,
      isDisabled,
      parentClass,
      category = [], // Ensure category is an array
      icol,
      message,
      fetch_onload,
      ...props
    },
    ref
  ) => {

    const client_state = useStore((state) => state.load_accounts);

    async function fetchData(active) {
      const { data } = await instance.get(`/fetch_accounts?s=all_clients&active=${active}`);
      return data;
    }

    const { data, error, isError, isLoading, isFetching, refetch } = useQuery(
      ["all_clients", active],
      () => fetchData(active),
      {
        keepPreviousData: true,
        staleTime: 600000,
        enabled: false,
      }
    );

    useEffect(() => {
      if (fetch_onload) {
        if (!data || !client_state) {
          refetch();
          useStore.setState({ load_accounts: true });
        }
      }
    }, [fetch_onload, data, client_state, refetch]);


    const handleClear = () => {
      handleChange('');
    };
    const handleChange = (newValue, option) => {
      if (!newValue) {
        onChange(null);
      } else {
        onChange(newValue, option);
      }
    };

    const fetchOptions1 = () => {
      if (!data || !client_state) {
        refetch();
        useStore.setState({ load_accounts: true });
      }
    };

    const filteredData = useMemo(() => {
      if (!data) return [];
      return data.items.filter((val) => category.length === 0 || category.includes(val.category));
    }, [data, category]);

    return (
      <div className={`${parentClass ? parentClass : "mb-4"} ${lcol ? "row" : ""}`}>
        {label && (
          <label className={`form-label ${lcol ? "pt-sm-2 col-sm-" + lcol : ""}`}>
            {label}{" "}
            <span className="text-red font-bold text-lg">
              {required && "*"}
            </span>
          </label>
        )}
        <div className={icol ? "col-sm-" + icol : ""}>
          <Select1
            name={name}
            disabled={isDisabled}
            status={message && "error"}
            value={value}
            onChange={handleChange}
            onClear={handleClear}
            suffixIcon={<MdOutlineKeyboardArrowDown />}
            clearIcon={<MdOutlineClose className="text-secondary" />}
            size='medium'
            labelInValue={true}
            style={{ width: '100%' }}
            loading={isFetching}
            onFocus={fetchOptions1}
            showSearch="multiple"
            notFoundContent={<div className="text-center">{isFetching ? 'Loading...' : 'No options'}</div>}
            optionLabelProp="label"
            allowClear={true}
            filterOption={(input, option) => option.label.toLowerCase().includes(input.toLowerCase()) || option.secondary.toLowerCase().includes(input.toLowerCase())}
            placeholder='Select...'
            ref={ref}
            className={`rselect ${message ? "is-invalid" : ""} ${className}`}
            {...props}
          >
            {filteredData.map((val, i) => (
              <Option key={i} value={val.value} label={val.label} state={val.state} secondary={val.secondary_text}>
                {val.label}
                {val.secondary_text && <small className="d-block">{val.secondary_text}</small>}
              </Option>
            ))}
          </Select1>
          {message && <div className="invalid-feedback">{message}</div>}
          <input type="hidden" name={name} value={value?.value ? value.value : ''} />
        </div>
      </div>
    );
  }
);



export const UiItemSelect = forwardRef(
  (
    {

      label,
      required,
      placeholder,
      loadOptions,
      active,
      className,
      value,
      name,
      lcol,
      isDisabled,
      parentClass,
      icol,
      message,
      fetch_onload,
      ...props
    },
    ref
  ) => {

    const client_state = useStore((state) => state.load_items);
    async function fetchData(active) {

      const { data } = await instance.get(
        "/fetch_items"
      );
      var dataa = data;
      return dataa;
    }

    const { data, error, isError, isLoading, isFetching, refetch } = useQuery(["items", active], () => fetchData(active), {
      keepPreviousData: true,
      staleTime: 600000,
      enabled: false
    });

    useEffect(() => {
      if (fetch_onload) {
       
        if (!data || client_state == false) {
          refetch()
          useStore.setState({ load_items: true });
        }
      }

    }, []);







    const fetchOptions1 = () => {
      if (!data || client_state == false) {
        refetch()
        useStore.setState({ load_items: true });
      }
    }


    return (
      <div className={`${parentClass ? parentClass : "mb-4"} ${lcol ? "row" : ""}`}>
        {label && (


          <label
            className={`form-label ${lcol ? "pt-sm-2 col-sm-" + lcol : ""
              }`}
          >
            {label}{" "}
            <span className="text-red font-bold text-lg">
              {required && "*"}
            </span>
          </label>
        )}
        <div className={icol ? "col-sm-" + icol : ""}>

          <Select1
            name={name}
            disabled={isDisabled}
            status={message && "error"}
            // value={value?.value ? { 'label': value.label, 'value': parseInt(value.value) } : null}
            value={value}
            suffixIcon={<MdOutlineKeyboardArrowDown />}
            clearIcon={<MdOutlineClose className="text-secondary" />}
            size='medium'
            labelInValue={true}
            style={{ width: '100%' }}
            loading={isFetching ? true : false}
            onFocus={() => fetchOptions1()}
            showSearch="multiple"
            notFoundContent={<div className="text-center">{isFetching ? 'Loading...' : 'No options'}</div>}
            //options={data ? data.items : []}
            optionLabelProp="label"
            allowClear={true}
            filterOption={(input, option) => (option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.secondary.toLowerCase().indexOf(input.toLowerCase()) >= 0)
            }
            placeholder='Select...'

            ref={ref}


            className={`rselect ${message ? "is-invalid" : ""
              } ${className}`}

            {...props}


          >
            {data?.items?.map((val, i) => (
              <Option key={i} value={val.value} label={val.label} selling_price={val.selling_price} gst={val.gst} secondary={val.secondary_text}>{val.label}{val.secondary_text &&
                <small className="d-block">{val.secondary_text}</small>
              }</Option>
            ))}
          </Select1>
          {message && <div className="invalid-feedback">{message}</div>}
          <input type="hidden" name={name} value={value?.value ? value.value : ''}></input>
        </div>
      </div>
    );
  }
);






export const UiSeriesSelect = forwardRef(
  (
    {

      label,
      required,
      placeholder,
      loadOptions,
      active,
      className,
      value,
      name,
      type,
      lcol,
      isDisabled,
      parentClass,
      icol,
      message,
      fetch_onload,
      ...props
    },
    ref
  ) => {

    const client_state = useStore((state) => state.load_series);
    async function fetchData(active) {

      const { data } = await instance.get(
        "/fetch_series"
      );
      var dataa = data;
      return dataa;
    }

    const { data, error, isError, isLoading, isFetching, refetch } = useQuery(["uiseries", active], () => fetchData(active), {
      keepPreviousData: true,
      staleTime: 600000,
      enabled: false
    });

    useEffect(() => {
      if (fetch_onload) {
        if (!data || client_state == false) {
          refetch()
          useStore.setState({ load_series: true });
        }
      }

    }, []);







    const fetchOptions1 = () => {
      if (!data || client_state == false) {
        refetch()
        useStore.setState({ load_series: true });
      }
    }


    return (
      <div className={`${parentClass ? parentClass : "mb-4"} ${lcol ? "row" : ""}`}>
        {label && (


          <label
            className={`form-label ${lcol ? "pt-sm-2 col-sm-" + lcol : ""
              }`}
          >
            {label}{" "}
            <span className="text-red font-bold text-lg">
              {required && "*"}
            </span>
          </label>
        )}
        <div className={icol ? "col-sm-" + icol : ""}>

          <Select1
            name={name}
            disabled={isDisabled}
            status={message && "error"}
            // value={value?.value ? { 'label': value.label, 'value': parseInt(value.value) } : null}
            value={value}
            suffixIcon={<MdOutlineKeyboardArrowDown />}
            clearIcon={<MdOutlineClose className="text-secondary" />}
            size='medium'
            labelInValue={true}
            style={{ width: '100%' }}
            loading={isFetching ? true : false}
            onFocus={() => fetchOptions1()}
            showSearch="multiple"
            notFoundContent={<div className="text-center">{isFetching ? 'Loading...' : 'No options'}</div>}
            //options={data ? data.items : []}
            optionLabelProp="label"
            allowClear={true}
            filterOption={(input, option) => (option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.secondary.toLowerCase().indexOf(input.toLowerCase()) >= 0)
            }
            placeholder='Select...'

            ref={ref}


            className={`rselect ${message ? "is-invalid" : ""
              } ${className}`}

            {...props}


          >
            {data?.items?.map((val, i) => (<>
              {(type && val.type == type) &&
                <Option key={i} value={val.value} label={val.label}>{val.label}</Option>
              }
            </>
            ))}
          </Select1>
          {message && <div className="invalid-feedback">{message}</div>}
          <input type="hidden" name={name} value={value?.value ? value.value : ''}></input>
        </div>
      </div>
    );
  }
);


export const titleCase = (str) => {
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}